import { useTranslation, type Locale } from "../lib/i18n";

// Simple EN/JA toggle. Production might add zh-CN / ko later.

export function LocaleSwitcher() {
  const { locale, setLocale } = useTranslation();

  const change = (l: Locale) => {
    setLocale(l);
  };

  return (
    <div className="inline-flex rounded-(--radius-pill) bg-(--color-canvas-card) p-0.5 text-[10px]">
      {(["en", "ja"] as Locale[]).map((l) => {
        const active = l === locale;
        return (
          <button
            key={l}
            onClick={() => change(l)}
            aria-pressed={active}
            className={[
              "rounded-(--radius-pill) px-2 py-0.5 uppercase transition-colors",
              active
                ? "bg-(--color-accent-gold) text-stone-900 font-medium"
                : "text-(--color-ink-faint) hover:text-(--color-ink)",
            ].join(" ")}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
}
